import { mods } from '@approvalmax/theme';
import { OldPhoneFilledIcon } from '@approvalmax/ui/src/icons';
import { InputDropdownIcon } from '@approvalmax/ui/src/old/icons';
import { StyledMods } from '@styled-kit/mods';
import { InfoIcon } from 'modules/sprites';
import { PhoneInputComponent } from 'pages/auth/pages/FirstTimeSetupPage/components';
import styled from 'styled-components';

export const StyledPhoneInputComponent = styled(PhoneInputComponent)`
    padding: 10px 28px 10px 52px;
`;

const flagWidth = 22;
const flagBorderRadius = 2;
const iconColor = '#777777';

export const PhoneSection = styled.div<StyledMods<{ hideFlag: boolean }>>`
    position: relative;

    ${mods('hideFlag', true)`
        ${StyledPhoneInputComponent} {
            padding-left: 3px;
        }
    `}

    // base on https://gitlab.com/catamphetamine/react-phone-number-input/-/blob/master/style.css

    .PhoneInput {
        display: flex;
        align-items: center;
    }

    .PhoneInputInput {
        flex: 1;
        min-width: 0;
    }

    .PhoneInputCountry {
        position: absolute;
        left: 5px;
        top: 50%;
        transform: translateY(-50%);
        align-self: stretch;
        display: flex;
        align-items: center;
        height: 100%;
        overflow: hidden;
    }

    .PhoneInputCountryIcon {
        width: ${flagWidth}px;
        flex: none;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .PhoneInputCountryIcon--border {
        position: relative;

        &::after {
            box-shadow: 0 0 0 1px inset rgba(0, 0, 0, 0.1);
            content: '';
            display: block;
            height: 100%;
            position: absolute;
            top: 0;
            width: 100%;
            border-radius: ${flagBorderRadius}px;
        }
    }

    .PhoneInputCountryIconImg {
        display: block;
        width: ${flagWidth}px;
        height: 15px;
        border-radius: ${flagBorderRadius}px;
    }

    .PhoneInputCountrySelect {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        z-index: 1;
        border: 0;
        opacity: 0;
        cursor: pointer;
    }
`;

export const PhoneDropdown = styled.div`
    position: absolute;
    right: 4px;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const PhoneInfoContainer = styled.div`
    color: ${iconColor};
    cursor: pointer;

    &:hover {
        color: #4c8a5c;
    }
`;

export const StyledMiniPhone = styled(OldPhoneFilledIcon)`
    color: ${iconColor};
`;

export const ArrowIcon = styled(InputDropdownIcon)`
    margin: 0 9px;
    width: 8px;
    height: 4px;
    flex: none;
`;

export const StyledInfoIcon = styled(InfoIcon)`
    display: block;
`;
